export default __webpack_public_path__ + "static/media/COL.fb530ac0.svg";